module.exports = __webpack_public_path__ + "static/media/chocolate-la-iguan-ok.43977e9d.jpg";